<template>
  <custom-dialog width="770px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form :model="form" :inline="true" ref="form" :rules="rules" label-width="110px">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$t('base_app_version_dialog.ying_yong_ming_cheng')" prop="appId">
              <custom-select
                v-model="form.appId"
                url="AppMenu"
                :model="form"
                :params="{ appTyp: 3 }"
                :props="{ label: 'appName', value: 'appId', map: { appName: 'appName' } }"
                :placeholder="$t('base_app_version_dialog.suo_shu_ying_yong')"
                width="220px"
                :dataFilter="dataFilter"
              ></custom-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('base_app_version_dialog.shi_yong_zhong_duan')" prop="versionOs">
              <custom-select code="app_version_os" v-model="form.versionOs" width="220px"></custom-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$t('base_app_version_dialog.ban_ben_hao')" prop="versionCode">
              <el-input v-model="form.versionCode" style="width: 220px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('base_app_version_dialog.sheng_ji_fang_shi')" prop="upgradeMode">
              <custom-select code="app_upgrade_mode" v-model="form.upgradeMode" width="220px"></custom-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item :label="$t('base_app_version_dialog.zi_yuan_wen_jian')" prop="attachBo">
            <t-upload type="file" :limit="1" :bizId="form.appVersionId" bizType="crm.app.package" v-model="form.attachList" ref="apk_file" :autoUpload="true"></t-upload>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item :label="$t('base_app_version_dialog.ban_ben_miao_shu')" prop="versionDesc">
            <el-input type="textarea" rows="8" v-model="form.versionDesc" style="width: 710px"></el-input>
          </el-form-item>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$t('base_app_version_dialog.sftzyh')" prop="isNotice">
              <el-switch v-model="form.isNotice" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button size="small" type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import tUpload from '@/components/upload';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  components: { tUpload },
  data() {
    return {
      form: {
        attachList: [], // 上传附件
        appId: '',
        appName: '',
        appVersionId: '',
        isDefault: 1,
        isNotice: 0,
        remark: '',
        attachBo: '',
        upgradeMode: '',
        versionCode: '',
        versionDesc: '',
        versionOs: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        appId: [{ required: true, message: this.$t('base_app_version_dialog.qxzyymc') }],
        versionOs: [{ required: true, message: this.$t('base_app_version_dialog.qxzsyzd') }],
        versionCode: [{ required: true, message: this.$t('base_app_version_dialog.qtxbbh') }],
        upgradeMode: [{ required: true, message: this.$t('base_app_version_dialog.qxzsjfs') }],
        isNotice: [{ required: true, message: this.$t('base_app_version_dialog.sftzyh') }],
        attachBo: [{ required: true, message: this.$t('base_app_version_dialog.qsczywj') }],
      };
    },
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      if (this.model.type === 'edit') {
        this.$setFormatData(this.form, this.model.row);
      }
    },
    dataFilter: function (list) {
      return list.filter((t) => t.appCode !== 'isynergy_cloud');
    },
    // 确认保存
    confirm: function () {
      this.form.attachBo = this.form.attachList[0] || '';
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.model.type === 'add') {
          this.saveInsert();
        }
        if (this.model.type === 'edit') {
          this.saveUpdate();
        }
      });
    },
    // 保存新增
    saveInsert: async function () {
      this.$postJSON(apis.AppVersionAdd, this.form).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.visible = false;
        this.$emit('success');
      });
    },
    // 保存编辑
    saveUpdate: function () {
      this.$postJSON(apis.AppVersionUpdate, this.form).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.visible = false;
        this.$emit('success', this.form);
      });
    },
  },
};
</script>

<style lang="scss"></style>
